import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { translations } from '../../utils/language'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../empreenderUI/ui/Select/Select'

export default function Pagination(props: any) {
  const language = useSelector((state: any) => state.reducerLanguage)
  const lang = language?.data || 'pt'
  const [pages, setPages] = useState([1])

  function getPages() {
    if (props.pagination == undefined) return
    const arrayPages: number[] = []
    for (let i = 0; i < props.pagination.last_page; i++) {
      arrayPages.push(i + 1)
    }
    setPages(arrayPages.length ? arrayPages : [1])
  }

  useEffect(() => {
    getPages()
  }, [props?.pagination])

  function handleGetData(page: any) {
    if (!Number.isNaN(page)) props.getData?.(page)
  }

  const current = props.pagination?.current_page || 1
  const last = props.pagination?.last_page || 1
  const perPage = props.pagination?.per_page || 0
  const total = props.pagination?.total || 0

  return (
    <div className="flex items-center justify-between bg-white px-4 py-3 sm:px-6">
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            {translations['table-showing'][lang]}{' '}
            <span className="font-medium">{current > 1 ? (current - 1) * perPage : 1}</span> {translations['table-to'][lang]}{' '}
            <span className="font-medium">{Math.min(current * perPage, total)}</span> {translations['products-pagination-de'][lang]}{' '}
            <span className="font-medium">{total}</span> {translations['products-pagination-resultados'][lang]}
          </p>
        </div>
        <div>
          <nav className="isolate inline-flex items-center gap-1" aria-label="Pagination">
            <button
              type="button"
              disabled={current <= 1}
              onClick={() => current > 1 && props.getData?.(current - 1)}
              className="relative inline-flex items-center rounded-lg px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-40"
            >
              <span className="sr-only">{translations['products-pagination-anterior'][lang]}</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            <Select value={String(current)} onValueChange={(v) => handleGetData(Number(v))}>
              <SelectTrigger className="h-9 w-[52px] rounded-lg text-sm">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {pages.map((p) => (
                  <SelectItem key={p} value={String(p)}>
                    {p}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <button
              type="button"
              disabled={current >= last}
              onClick={() => current < last && props.getData?.(current + 1)}
              className="relative inline-flex items-center rounded-lg px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-40"
            >
              <span className="sr-only">{translations['table-next'][lang]}</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  )
}
